import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private url: string
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  private readonly notFound = -1
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  private readonly zero = 0
  constructor(@Inject(DOCUMENT) private readonly dom) {}

  createLinkForCanonicalURL(key: string) {
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    this.url = this.dom.URL.toLowerCase()
    this.url = this.url.split('?')[this.zero]
      if (!this.url.includes(key)) {
      this.url = this.url.concat(key)
    }
    element.setAttribute('rel','canonical')
    if(key !== 'non-vanguard-mutual-funds'){
      element.setAttribute('href',this.url)
    }else{
      element.setAttribute('href', this.url.replace('non-vanguard-mutual-funds', 'all'))
    }
  }
}
